import styled from 'styled-components';

export const FooterContainer = styled.footer`
	width: 100%;
	margin-top: 8rem;

	border-top: 1px solid var(--color-line);

	> .content:not(.copyright) {
		display: grid;
		grid-template-columns: 1fr auto auto;
		gap: 12rem;

		min-height: 20rem;
		padding: 6rem 0 10rem;

		.main {
			display: flex;
			flex-direction: column;
			gap: 1.6rem;

			width: 45rem;

			h1 {
				font-size: calc(var(--title-size) + 0.2rem);
				line-height: 1.4;
			}

			p {
				font-size: var(--text-size);
				line-height: 1.5;
			}

			.button {
				margin-top: 0.8rem;

				.aresui-button {
					&:hover {
						color: #000;
					}
				}
			}
		}

		.column {
			display: flex;
			flex-direction: column;
			gap: 2.4rem;

			strong {
				font-size: calc(var(--text-size) + 0.6rem);
				font-weight: 500;
				color: #fff;
			}

			ul {
				display: flex;
				flex-direction: column;
				gap: 0.4rem;

				li {
					list-style: none;

					small {
						font-size: calc(var(--text-size) - 0.2rem);
						opacity: 0.8;
					}

					a {
						font-size: calc(var(--text-size) + 0.2rem);
						line-height: 1.5;

						&:hover {
							color: #fff;
						}
					}

					&.contact {
						display: flex;
						flex-direction: column;
						gap: 0.2rem;

						+ .contact {
							margin-top: 1.2rem;
						}

						a {
							color: #fff;

							&:hover {
								text-decoration: underline;
							}
						}
					}
				}
			}
		}
	}

	.content.copyright {
		width: 100%;
		/* background: var(--color-surface); */

		.content {
			display: flex;
			align-items: center;
			flex-direction: row-reverse;
			justify-content: space-between;

			padding: 2.4rem 0;
			border-top: 1px solid var(--color-line);

			font-size: calc(var(--text-size) - 0.2rem);

			a {
				display: flex;
				align-items: center;
				gap: 0.8rem;

				&:hover {
					color: #fff;
				}
			}
		}
	}

	@media (max-width: 820px) {
		> .content:not(.copyright) {
			grid-template-columns: 1fr;
			gap: 8rem;

			.main {
				align-items: center;
				text-align: center;

				width: 100%;
			}

			.column {
				align-items: center;
				text-align: center;

				&:nth-child(2) {
					display: none;
				}
			}
		}
	}

    @media (max-width: 720px) {
        .content.copyright {
            .content {
                flex-direction: column;
                text-align: center;
                gap: 2.4rem;
            }
        }
    }
`;

export default FooterContainer;
